<template>
  <v-container>
    <v-layout>
      <v-flex xs1>
        <v-select :color="Theme.GREEN"
                  :items="getFilterType"
                  :label="'篩選'"
                  item-text="text" item-value="key"
                  v-model="filter"
        @change="changeFilterType()"/>
      </v-flex>
      <v-flex>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢門市名稱"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark @click.prevent="addNew">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
        @changePage="changePage"
        @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <store-detail
        :title="editView.title" :visible="editView.visible"
                  :item-detail="editView.item"
                  :show-cancel="editView.showCancel"
                  @cancelEvent="editView.cancelEvent"
                  @confirmEvent="editView.confirmEvent"/>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import StoreDetail from "./StoreDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";

export default {
  name: "store",
  components: {
    TableView, StoreDetail
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      filter: -1,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getFilterType() {
      return [
        {key: -1, text:'所有'},
        {key: 0, text:'材料門市'},
        // {key: 1, text:'藥妝'},
      ]
    },
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'name', text:'門市名稱', sortable: true },
        { value:'cellphone', text:'門市電話', sortable: false },
        { value:'time', text:'營業時間', sortable: false },
        { value:'address', text:'地址', sortable: false },
        // { value:'latitude', text:'緯度', sortable: false },
        // { value:'longitude', text:'經度', sortable: false },
        { value:'target', text:'顯示', options: this.getStoreTargetList, sortable: false },
        { value:'storeType', text:'類型', options: this.getStoreTypeList, sortable: false },
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }

  },
  methods:{
    ...mapActions(['getStoreList','deleteStoreInfo']),
    changeFilterType(){
      this.loadData();
    },
    async loadData(){
      this.loading = true;
      const res = await this.getStoreList({
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
        searchValue:this.searchValue,
        storeType: this.filter,
        admin: '1',
      });

      if (res.data.code === 0){
        this.list = res.data.body.list;
        this.pagination.totalItems = res.data.body.header.totalCount;

        console.log(`getStoreList ${JSON.stringify(res.data.body.list)}`);
      }
      this.loading = false;
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此門市？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增門市':'修改門市'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteStoreInfo({
        storeId: item.storeId,
      });

      if (res.data.code === 0){
        this.reset();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          storeId: this.uuid.v4(),
          name:'',
          time:'',
          cellphone:'',
          city:'',
          street:'',
          address:'',
          latitude:'',
          longitude:'',
          target:0,
          storeType:0,
          products:'',
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
